import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Api, getSession, updateSession } from '../../api/Assinafy';
import { Page } from '../../layout';
import { Alert, Button, Icon, Input } from '../../components';
import Form, { createInputChange, createInputBlur, createInputError } from '../../components/Form';

import './styles.scss';

export const SIGNUP_INTEREST_OPTIONS = [
  {
    label: 'Enviar documentos para meus clientes assinarem',
    value: 'send_documents'
  },
  {
    label: 'Assinar meus próprios documentos',
    value: 'sign_own_documents'
  },
  {
    label: 'Integrar com API de assinatura',
    value: 'signature_api'
  },
  {
    label: 'Integrar com meu sistema/software',
    value: 'system_integration'
  }
]

export const sessionUpdateFromInterestResponse = (data, currentSession) => {
  if (!data || typeof data !== 'object') return {}

  const { accounts, user, ...flatUser } = data
  const returnedUser = user || (data.id ? flatUser : null)
  const sessionUpdate = {}

  if (returnedUser) {
    sessionUpdate.user = {
      ...currentSession?.user,
      ...returnedUser
    }
  }

  if (Array.isArray(accounts)) {
    sessionUpdate.accounts = accounts
  }

  return sessionUpdate
}

const SignupReason = () => {
  const navigate = useNavigate()
  const [formValidation, setFormValidation] = useState([])
  const [formData, setFormData] = useState({})
  const [formError, setFormError] = useState([])
  const [loading, setLoading] = useState(false)

  const handleSubmit = (event) => {
    event.preventDefault()

    setFormValidation([])

    if (event.target.checkValidity()) {
      setLoading(true)
      setFormError([])

      Api('user/updateInterest')(formData.interest)
        .then(({ status, data: { data } }) => {
          if (status === 200) {
            const sessionUpdate = sessionUpdateFromInterestResponse(data, getSession())
            if (Object.keys(sessionUpdate).length) updateSession(sessionUpdate)
            navigate('/email-verification', { replace: true })
          }
        })
        .catch(({ response }) => {
          setFormError([
            response?.data?.message || 'Não foi possível salvar seu interesse. Tente novamente.'
          ])
          setLoading(false)
        })
    } else {
      Array.from(event.target.elements).map((element) => {
        if (element.name) {
          setFormValidation((prevState) => [
            ...prevState,
            { name: element.name, message: element.validationMessage }
          ])
        }
      })
    }
  }

  const handleChange = createInputChange(formData, setFormData)

  const handleBlur = createInputBlur(formValidation, setFormValidation)

  const showInputError = createInputError(formValidation)

  useEffect(() => {
    const { access_token, user } = getSession()

    if (!access_token || !user) {
      navigate('/signup', { replace: true })
      return
    }

    if (user.has_selected_interest === true) {
      navigate('/email-verification', { replace: true })
    }
  }, [navigate])

  return (<>
    <Page className="page-sign"
      title="Qual o seu principal interesse na Assinafy?"
      opening="Deixe-nos saber o que é mais importante para você!"
      >
        <Alert show={formError.length} variant="warning" onClose={() => setFormError([])}>
          {formError.map((error) => error)}
        </Alert>

      <Form id="form-signup" className="form-sign"
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <Form.Group>
            <Form.ChoiceList
                options={SIGNUP_INTEREST_OPTIONS}
                control={Input.Radio}
                controlProps={{
                  name: "interest",
                  required: true,
                  onChange: handleChange,
                  onBlur: handleBlur
                }}
            />
          {showInputError('interest')}
        </Form.Group>

        <Form.Footer>
          <Button variant="primary" size="lg" submit loading={loading}>
            Continuar
            <Icon id="icon-arrow_forward" className="ms-2" size="24" />
          </Button>
        </Form.Footer>
      </Form>

    </Page>
  </>);
};

export default SignupReason;
